<script setup lang="ts">
import { TSDialogConfirm, useLoadingStore, useToast } from 'tsv2-library';

import BorrowingServices from '@/services/borrowing.service';

import useTableStore from '@/store/table.store';

import {
  BorrowingBorrowedByAsset,
  BorrowingTransactionRequest,
} from '@/types/borrowing.type';

const toast = useToast();
const { incrementTableKey } = useTableStore();
const { setLoading } = useLoadingStore();

const visible = defineModel<boolean>('visible', { required: true });

const props = defineProps<{
  selectedData: BorrowingTransactionRequest[] | BorrowingBorrowedByAsset[];
}>();

/**
 * Handle the cancelation to borrowing asset.
 */
const handleCancelBorrowing = async (): Promise<void> => {
  try {
    setLoading(true);

    await BorrowingServices.putCancelBorrowingRequest(
      props.selectedData.map((datum) => datum._id),
    );

    toast.add({
      message: 'Success, borrowing transaction has been canceled.',
      severity: 'success',
    });

    incrementTableKey();
  } catch (error) {
    toast.add({
      error,
      message: 'Error, failed to cancel borrowing transaction.',
      severity: 'error',
    });
  } finally {
    setLoading(false);
  }
};
</script>
<template>
  <TSDialogConfirm
    v-model:visible="visible"
    :lists="selectedData.map((datum) => datum.name.nameWithSequence)"
    @confirm="handleCancelBorrowing"
    body="Are you sure want to continue?"
    confirm-label="Continue"
    data-ts-name="cancel-borrowing-transaction"
    header="Cancel Borrowing Transaction"
    severity="danger"
  />
</template>
